import "./Footer.css";

export const Footer = () => {
  return (
    <footer className="container-footer">
      <p>
      ©️ made with ♡ <span className="white-text">| takwa laffet</span> 

      </p>
    </footer>
  );
};
